import { EVENT_DETAILS_FIELD, EVENT_SOURCE_FIELD, EVENT_TARGET_FIELD, SEVERITY_FIELD } from 'schemas/constants';
import { DEFAULT_FIELDS } from 'schemas/default-fields';
import { DATASOURCE, FIELD_TYPE, Schema } from 'schemas/types';

export const schema: Schema = {
  dataSource: DATASOURCE.VECTRA,
  dataSourceId: 'Vectra',
  dataSourceVendor: 'Vectra',
  dataSourceLabel: 'Vectra',
  fields: {
    ...DEFAULT_FIELDS,
    [EVENT_DETAILS_FIELD]: {
      type: FIELD_TYPE.EVENT_DETAILS,
      label: 'Event Details',
      notSearchable: true,
      description: 'Event additional details',
      width: 900, // (160 + 20) x 5
      relatedFieldsMap: { network: ['event.externalThreatValue', SEVERITY_FIELD, 'event.certainty'] },
    },
    [EVENT_SOURCE_FIELD]: {
      label: 'Event Source',
      type: FIELD_TYPE.EVENT_SOURCE,
      notSearchable: true,
      relatedFields: ['endpoint.name', 'src.ip.address', 'event.login.accountName'],
      width: 540, // (160 + 20) x 3
    },
    [EVENT_TARGET_FIELD]: {
      label: 'Event Target',
      type: FIELD_TYPE.EVENT_TARGET,
      notSearchable: true,
      relatedFields: ['dst.ip.address', 'event.dns.request'],
      width: 540, // (160 + 20) x 3
    },
    'event.dns.request': {
      type: FIELD_TYPE.DNS,
      label: 'DNS Request',
      description: 'DNS name',
    },
    'event.externalThreatValue': {
      label: 'Event External Threat Value',
      type: FIELD_TYPE.TEXT,
    },
    'event.certainty': {
      label: 'Event Certainty',
      type: FIELD_TYPE.TEXT,
    },
    'endpoint.name': {
      label: 'Endpoint Name',
      type: FIELD_TYPE.DEVICE,
    },
    'src.ip.address': {
      label: 'Source IP Address',
      type: FIELD_TYPE.IP_ADDRESS,
    },
    'dst.ip.address': {
      label: 'Destination IP Address',
      type: FIELD_TYPE.IP_ADDRESS,
    },
    'event.login.accountName': {
      label: 'Login Account Name',
      type: FIELD_TYPE.USER,
    },
  },
  summaryFieldIds: ['endpoint.name', 'event.login.accountName', 'src.ip.address', 'dst.ip.address'],
};
